// React versions of the extra hub sections. Same data and wording as
// scripts/lib/hub-sections.js; the browser also marks tonight (Central time).
var React = require('react');
var Link = require('react-router').Link;
var hubWeek = require('./hub-week');
var hubExtras = require('./hub-extras');
var METRO_HUBS = require('./metro-hubs');
var encodeSlug = require('./room-slug');

var WEEK_NOTE = 'Times and buy-ins are what each room posted. Confirm with the club before you go, since holidays and series change the calendar.';

function todayName() {
  try {
    return new Date().toLocaleDateString('en-US', { weekday: 'long', timeZone: 'America/Chicago' });
  } catch (e) {
    return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][new Date().getDay()];
  }
}

// Tonight first, then the rest of the week in order.
function rotateToToday(days) {
  var today = todayName();
  var at = -1;
  days.forEach(function(d, i) { if (d.day === today) at = i; });
  if (at < 0) return { days: days, today: null };
  return { days: days.slice(at).concat(days.slice(0, at)), today: today };
}

function roomLink(name, key) {
  return <Link key={key || name} to={'/allcasinos/' + encodeSlug(name)}>{name}</Link>;
}

function buyinText(buyin) {
  return hubWeek.isFree(buyin) ? 'free entry (club fees may apply)' : buyin + ' buy-in';
}

function eventItem(row, i) {
  return (
    <li key={row.casino + row.name + i}>
      <strong>{row.start || 'Time not listed'}</strong>{' '}
      {roomLink(row.casino, 'r' + i)}
      {row.name ? ': ' + row.name : ''}
      {row.buyin ? ' · ' + buyinText(row.buyin) : ''}
    </li>
  );
}

function monthlyBlock(week) {
  if (!week.monthly.length) return null;
  return (
    <div>
      <h3>Monthly events</h3>
      <ul className="hub-week-list">
        {week.monthly.map(function(row, i) {
          return (
            <li key={'m' + i}>
              {roomLink(row.casino, 'm' + i)}{row.name ? ': ' + row.name : ''}{' · ' + row.dayLabel}{row.start ? ' · ' + row.start : ''}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

function metroOf(name) {
  var hit = null;
  Object.keys(METRO_HUBS).forEach(function(slug) {
    if (hit) return;
    if ((METRO_HUBS[slug].rooms || []).some(function(r) { return r.name === name; })) {
      hit = { slug: slug, label: METRO_HUBS[slug].shortLabel || METRO_HUBS[slug].footerLabel };
    }
  });
  return hit;
}

var HubWeek = React.createClass({
  render: function() {
    var p = this.props;
    var week = hubWeek.build(p.roomNames);
    if (!week.eventCount) return null;
    var rotated = rotateToToday(week.days);
    var lead = hubWeek.facts(week, p.areaLabel) +
      (p.summary ? ' Find tonight\u2019s day below; each city page lists its rooms and their schedules. ' : ' Find tonight\u2019s day below. ') +
      WEEK_NOTE;
    var body;
    if (!p.summary) {
      body = rotated.days.map(function(day) {
        if (!day.events.length) return null;
        var label = day.day === rotated.today ? 'Tonight (' + day.day + ')' : day.day;
        return (
          <div key={day.day} className={day.day === rotated.today ? 'hub-week-day hub-week-today' : 'hub-week-day'}>
            <h3>{label}</h3>
            <ul className="hub-week-list">{day.events.map(eventItem)}</ul>
          </div>
        );
      });
    } else {
      var hubOrder = Object.keys(METRO_HUBS);
      body = (
        <ul className="hub-week-summary">
          {rotated.days.map(function(day) {
            if (!day.events.length) return null;
            var counts = {};
            var order = [];
            var elsewhere = 0;
            day.events.forEach(function(row) {
              var metro = metroOf(row.casino);
              if (!metro) { elsewhere++; return; }
              if (!counts[metro.slug]) { counts[metro.slug] = { label: metro.label, n: 0 }; order.push(metro.slug); }
              counts[metro.slug].n++;
            });
            order.sort(function(a, b) { return hubOrder.indexOf(a) - hubOrder.indexOf(b); });
            var bits = [];
            order.forEach(function(slug, i) {
              if (i > 0) bits.push(' · ');
              bits.push(<Link key={slug} to={'/' + slug}>{counts[slug].label}</Link>);
              bits.push(' ' + counts[slug].n);
            });
            if (elsewhere) bits.push((order.length ? ' · ' : '') + 'elsewhere ' + elsewhere);
            var t = day.topGtd;
            var isToday = day.day === rotated.today;
            return (
              <li key={day.day} className={isToday ? 'hub-week-today' : ''}>
                <strong>{isToday ? 'Tonight (' + day.day + ')' : day.day}</strong>
                {': ' + day.events.length + ' tournaments at ' + day.roomCount + ' rooms ('}{bits}{').'}
                {t ? <span>{' Largest guarantee on file: ' + t.name + ' at '}{roomLink(t.casino, 'top')}{(t.start ? ', ' + t.start : '') + (t.buyin ? ', ' + (hubWeek.isFree(t.buyin) ? 'free entry' : t.buyin + ' buy-in') : '') + '.'}</span> : null}
                {isToday ? <ul className="hub-week-list">{day.events.map(eventItem)}</ul> : null}
              </li>
            );
          })}
        </ul>
      );
    }
    return (
      <section className="hub-week">
        <h2>{p.areaLabel + ' poker tournaments tonight and this week'}</h2>
        <p>{lead}</p>
        {body}
        {monthlyBlock(week)}
      </section>
    );
  }
});

function CardRooms(props) {
  var extra = hubExtras[props.slug];
  if (!extra || !extra.cardRooms) return null;
  return (
    <section className="hub-card-rooms">
      <h2>{extra.cardRooms.h}</h2>
      {extra.cardRooms.p.map(function(text, i) { return <p key={i}>{text}</p>; })}
    </section>
  );
}

function Stay(props) {
  var extra = hubExtras[props.slug];
  if (!extra || !extra.stay) return null;
  return (
    <section className="hub-stay">
      <h2>{extra.stay.h}</h2>
      <p>{extra.stay.lead}</p>
      {extra.stay.areas.map(function(area) {
        return (
          <div key={area.label}>
            <h3>{area.hub ? <Link to={area.hub}>{area.label}</Link> : area.label}</h3>
            <ul className="hub-stay-rooms">
              {area.rooms.map(function(r) {
                return <li key={r.name}>{roomLink(r.name)}{': ' + r.address}</li>;
              })}
            </ul>
          </div>
        );
      })}
    </section>
  );
}

function AlsoRooms(props) {
  var hub = props.hub;
  if (!hub || !hub.alsoRooms || !hub.alsoRooms.length) return null;
  var area = String(hub.shortLabel || hub.footerLabel).replace(/ area$/, '');
  var bits = [];
  hub.alsoRooms.forEach(function(r, i) {
    if (i > 0) bits.push(<span key={'s' + i} aria-hidden="true"> · </span>);
    bits.push(roomLink(r.name));
  });
  return <p className="hub-also-rooms">{'Also on file in the ' + area + ' area, with no tournament schedule listed: '}{bits}</p>;
}

module.exports = {
  HubWeek: HubWeek,
  CardRooms: CardRooms,
  Stay: Stay,
  AlsoRooms: AlsoRooms
};



// WEBPACK FOOTER //
// ./js/hub-sections.jsx